 
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import MainDashboard from "./MainDashboard";
import Login from "./Login";
import PrivateRoute from "./PrivateRoute";  
import { ToastContainer } from 'react-toastify';
import VendusDocuments from "./VendusDocuments";
import DashboardLayout from "./DashboardLayout";
import ManagerMain from "./Pages/ManagerMain";
import TechApp from "./Pages/TechApp";

function App() {
  return (
    <Router>
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/docs" element={<VendusDocuments />} />
  
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <MainDashboard />
          </PrivateRoute>
        }
      />
        <Route
        path="/app"
        element={
          <PrivateRoute>
            <TechApp />
          </PrivateRoute>
        }
      />
    </Routes>
  </Router>
  
  );
}

export default App;
